import React, { FC } from 'react'
import { ClientError } from 'modules/Errors/components'
import { ErrorPageContent } from 'components'
import styles from 'pages/Errors/Unautorized/Unauthorized.module.scss'
import { Button } from '@wmgtech/legato'
import { useNavigate } from 'react-router-dom'

type TNotFoundProps = {}

export const NotFound: FC<TNotFoundProps> = (props) => {
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
      <ErrorPageContent
        title="Not Found"
        description="The page you are looking for does not exist."
        children={<ClientError />}
      />
      <div className={styles.buttonContainer}>
        <Button size="lg" onClick={() => navigate(-1)}>Go back</Button>
        <Button size="lg" onClick={() => navigate('/')}>Go to homepage</Button>
      </div>
    </div>
  )
}
